import React from 'react'
import { WifiOff, Wifi } from 'lucide-react'
import { useConnectivity } from '../contexts/ConnectivityContext'

export default function OfflineBanner() {
  const { isOnline } = useConnectivity()
  if (isOnline) return null
  return (
    <div role="status" aria-live="polite" className="fixed top-0 left-0 right-0 z-50">
      <div className="mx-auto max-w-screen-2xl px-3 py-2">
        <div className="rounded-md bg-amber-50 border border-amber-200 text-amber-900 px-3 py-2 shadow-sm flex items-center gap-2">
          <WifiOff className="w-4 h-4" />
          <span className="text-sm font-medium">Verbindung verloren – arbeite offline. Wiederverbinden…</span>
        </div>
      </div>
    </div>
  )
}
